import React, { useState } from "react";
import { Form, InputGroup, Dropdown, Button, Container } from "react-bootstrap";
import { LuSearch } from "react-icons/lu";
import { FaChevronDown } from "react-icons/fa6";

const SearchArticle = () => {
  const [selectedCategory, setSelectedCategory] = useState("Cardiology");

  const handleSelect = (eventKey) => {
    setSelectedCategory(eventKey);
  };

  return (
    <div className="search-article-container">
      <Container>
        <div className="search-header text-center">
          <h2>Looking for best Article?</h2>
          <p>
            Type a disease, keyword, or question and explore easy-to-read
            research summaries made just for you.
          </p>
        </div>

        <div className="search-box">
          <InputGroup>
            <Dropdown onSelect={handleSelect}>
              <Dropdown.Toggle
                variant="light"
                id="dropdown-basic"
                className="category-dropdown d-flex justify-content-between align-items-center"
              >
                <span>{selectedCategory}</span>
                <FaChevronDown className="dropdown-icon" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="Cardiology">Cardiology</Dropdown.Item>
                <Dropdown.Item eventKey="Respiratory Diseases">
                  Respiratory Diseases
                </Dropdown.Item>
                <Dropdown.Item eventKey="Neurological Disorders">
                  Neurological Disorders
                </Dropdown.Item>
                <Dropdown.Item eventKey="Endocrine Disorders">
                  Endocrine Disorders
                </Dropdown.Item>
                <Dropdown.Item eventKey="Genetic and Rare Diseases">
                  Genetic and Rare Diseases
                </Dropdown.Item>
                <Dropdown.Item eventKey="Cancer">Cancer</Dropdown.Item>
                <Dropdown.Item eventKey="Infectious Diseases">
                  Infectious Diseases
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Form.Control
              type="text"
              placeholder="Search"
              className="search-input"
            />

            <Button variant="success" className="search-btn">
              <LuSearch />
            </Button>
          </InputGroup>
        </div>
      </Container>
    </div>
  );
};

export default SearchArticle;
